export function showNotice(
	notice: HTMLElement | null,
	content: string,
	status?: string,
	usePbfNotice?: boolean,
) {
	if (!notice) return;
	notice.textContent = content;

	if (status) {
		if (status === "success") {
			notice.classList.remove("is-failed");
			notice.classList.add("is-success");

			if (usePbfNotice) {
				notice.classList.remove("wpbf-notice-error");
				notice.classList.add("wpbf-notice-success");
			}
		} else if (status === "failed" || status === "error") {
			notice.classList.remove("is-success");
			notice.classList.add("is-failed");

			if (usePbfNotice) {
				notice.classList.remove("wpbf-notice-success");
				notice.classList.add("wpbf-notice-error");
			}
		}
	}

	notice.classList.remove("is-hidden");
}

export function hideNotice(notice: HTMLElement | null, usePbfNotice?: boolean) {
	if (!notice) return;

	notice.classList.add("is-hidden");
	notice.textContent = "";

	if (usePbfNotice) {
		notice.classList.remove("wpbf-notice-success");
		notice.classList.remove("wpbf-notice-error");
	}
}
